'use client'

import PropTypes from 'prop-types'
import { WizardPanel } from '@repo/ui/WizardPanel'
import { WizardFooter } from '@repo/ui/WizardFooter'
import MUITypography from '@mui/material/Typography'
import MUIStack from '@mui/material/Stack'
import { LargeClientSuccessIcon } from '@repo/ui/LargeClientSuccessIcon'

export const NewClientSummary = ({ wideMode, handlePrevNext, updateStepState }) => {
  const handleClickContinue = () => {
    updateStepState({ status: 'completed', statusText: 'Complete' })
    handlePrevNext(1)
  }

  const handleClickBack = () => {
    handlePrevNext(-1)
  }

  return (
    <>
      <WizardPanel data-testid="NewClientSummary">
        <MUIStack
          direction="column"
          gap={4}
          justifyContent="center"
          alignItems="center"
          sx={{ height: '420px', maxWidth: '500px', margin: '0 auto' }}
        >
          <LargeClientSuccessIcon sx={{ width: '90px', height: '90px', mb: '32px' }} />

          <MUITypography variant="h4" sx={{ mb: 0 }}>
            New client details entered successfully
          </MUITypography>

          <MUITypography variant="body1" sx={{ mb: 0, textAlign: 'center' }}>
            {`You've entered all the required fields to set up a new client. Press 'Continue' to create a matter against
            the new client.`}
          </MUITypography>
        </MUIStack>
      </WizardPanel>
      <WizardFooter wideMode={wideMode} handleClickContinue={handleClickContinue} handleClickBack={handleClickBack} />
    </>
  )
}

NewClientSummary.propTypes = {
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func,
  updateStepState: PropTypes.func
}
